(() => {
  const CONSENT_COOKIE = 'ldj_consent';
  const DISMISSED_COOKIE = 'ldj_newsletter_dismissed';
  const CONSENT_SET_EVENT = 'ldj:consent-set';

  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${name}=([^;]*)`)
    );

    return match ? decodeURIComponent(match[1]) : null;
  };

  const setCookie = (name, value, days) => {
    const expires = new Date(
      Date.now() + days * 24 * 60 * 60 * 1000
    ).toUTCString();

    document.cookie =
      `${name}=${encodeURIComponent(value)};` +
      `expires=${expires};` +
      `path=/;SameSite=Lax`;
  };

  const init = () => {
    const modal = document.querySelector('[data-newsletter-modal]');

    if (!modal) return;
    if (modal.dataset.initialized === 'true') return;

    modal.dataset.initialized = 'true';

    const delay = Number(modal.dataset.delay || 3000);

    const closeButtons = modal.querySelectorAll('[data-newsletter-close]');
    const panel = modal.querySelector('[data-newsletter-panel]');
    const form = modal.querySelector('[data-newsletter-form]');
    const emailInput = modal.querySelector('[data-newsletter-email]');
    const submitButton = modal.querySelector('[data-newsletter-submit]');
    const success = modal.querySelector('[data-newsletter-success]');
    const error = modal.querySelector('[data-newsletter-error]');

    let timer = null;
    let scheduled = false;

    const show = () => {
      if (getCookie(DISMISSED_COOKIE)) return;

      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
    };

    const scheduleShow = () => {
      if (scheduled || getCookie(DISMISSED_COOKIE)) return;

      scheduled = true;

      timer = window.setTimeout(show, delay);
    };

    const dismiss = () => {
      if (timer) {
        window.clearTimeout(timer);
      }

      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');

      setCookie(DISMISSED_COOKIE, '1', 30);
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', dismiss);
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        dismiss();
      }
    });

    panel?.addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
        dismiss();
      }
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();

      const email = emailInput?.value.trim();

      if (!email) return;

      error?.classList.remove('is-visible');

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sending...';
      }

      try {
        const formData = new URLSearchParams();

        formData.append('EMAIL', email);
        formData.append('b_307245e4e6578cfac5982fd14_2305fddae1', '');

        await fetch(
          'https://luisdejavier.us9.list-manage.com/subscribe/post?u=307245e4e6578cfac5982fd14&id=2305fddae1&f_id=00f75be1f0',
          {
            method: 'POST',
            body: formData,
            mode: 'no-cors'
          }
        );

        form.classList.add('is-hidden');
        success?.classList.add('is-visible');

        setCookie(DISMISSED_COOKIE, '1', 30);

        window.setTimeout(() => {
          modal.classList.remove('is-visible');
          modal.setAttribute('aria-hidden', 'true');
        }, 2000);
      } catch (err) {
        error?.classList.add('is-visible');

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Send';
        }
      }
    });

    if (getCookie(DISMISSED_COOKIE)) return;

    if (getCookie(CONSENT_COOKIE)) {
      scheduleShow();
    } else {
      window.addEventListener(CONSENT_SET_EVENT, scheduleShow, { once: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
